export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};


export function formatDateForInput(mongoDate) {
  const date = new Date(mongoDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}


export function formatDateandtime(dateString) {
  const date = new Date(dateString);

  // Get local date parts
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear().toString().slice(-2);

  // Get local time parts
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Format hours to 12-hour clock
  const formattedHours = hours % 12 || 12;

  // Format minutes with leading zero if needed
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  // Construct the final formatted date string
  return `${day}-${month}-${year} ${formattedHours}:${formattedMinutes} ${ampm}`;
}

export function getFileNameFromUrl(url) {
  const parts = url.split('/');
  const fileName = decodeURIComponent(parts.pop());
  const partsfileName = fileName.split('-');
  const fileNameFinal = decodeURIComponent(partsfileName.pop());
  return fileNameFinal.trim();
}


export function getfileTypefromurl(url) {
  const parts = url.split('/');
  const fileName = decodeURIComponent(parts.pop());
  const partsfileName = fileName.split('-');
  const fileNameFinal = decodeURIComponent(partsfileName.pop());
  const partstype = fileNameFinal.split('.');
  const filetype = decodeURIComponent(partstype.pop());
  return filetype.trim();
}


export const OfferStep = (step) => {
  switch (step) {
    case "New":
      return [{ stage: "Offer Created", Date: "" }];
    case "In progress":
      return [
        { stage: "Offer Accepted", Date: "" },
        { stage: "Offer Created", Date: "" }
      ];
    case "Declined":
      return [
        { stage: "Offer Declined", Date: "" },
        { stage: "Offer Created", Date: "" }
      ];
    case "Delivered":
      return [
        { stage: "Offer Delivered", Date: "" },
        { stage: "Offer Accepted", Date: "" },
        { stage: "Offer Created", Date: "" }
      ];
    case "Completed":
      return [
        { stage: "Offer Completed", Date: "" },
        { stage: "Offer Delivered", Date: "" },
        { stage: "Offer Accepted", Date: "" },
        { stage: "Offer Created", Date: "" }
      ];
    case "Under review":
      return [
        { stage: "Under Review", Date: "" },
        { stage: "Offer Delivered", Date: "" },
        { stage: "Offer Accepted", Date: "" },
        { stage: "Offer Created", Date: "" }
      ];
    default:
      return [
        { stage: "Offer Delivered", Date: "" },
        { stage: "Offer Accepted", Date: "" },
        { stage: "Offer Created", Date: "" }
      ];
  }
}


export function getLastSixChars(id) {
  
  // Check if the id is a string and has at least 4 characters
  if (typeof id === 'string' && id.length >= 6) {
      // Return the last four characters
      
      return id.slice(-6);
  } else {
      // Handle cases where id is not a string or has less than 4 characters
      return 'Invalid ID';
  }
}



export function trimDescription(description) {
  // Split the description into words
  const words = description?.split(" ");
  
  // Check if the word count exceeds 10
  if (words?.length > 10) {
      // Return the first 10 words joined with a space and append '...'
      return words.slice(0, 10).join(" ") + " ...";
  }
  
  // If 10 words or less, return the description as is
  return description;
}


export function formatPrice(price) {
  if (price >= 1_00_00_00_000) {
      return (price / 1_00_00_00_000).toFixed(2) + " Cr"; // Crore
  } else if (price >= 1_00_00_000) {
      return (price / 1_00_00_000).toFixed(2) + " Cr"; // Crore
  } else if (price >= 1_00_000) {
      return (price / 1_00_000).toFixed(2) + " Lac"; // Lac
  } else if (price >= 1_000) {
      return (price / 1_000).toFixed(2) + " K"; // Thousand
  } else {
      return price.toString(); // Less than thousand, return as is
  }
}